import { render } from "./InputColor.vue?vue&type=template&id=e753544a"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__